var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require( 'react-helmet' );
var Loader = require('react-loader');
var AppPromo = require('../../components/appPromo.jsx');
var ConditionNavList = require('./layout/condtionNavList.jsx');
var ContentHeader = require('./layout/contentHeader.jsx');

var Conditions = createReactClass({
  mixins: [PureRenderMixin],

  componentDidMount: function () {
    this.props.fetchConditionsIfNeeded();
  },

  componentWillReceiveProps: function(nextProps){
      if(nextProps.location.key !== this.props.location.key){
          this.clearStatesAsNeeded();
      }
  },

  componentWillUnmount: function(){
      this.clearStatesAsNeeded();
  },

  clearStatesAsNeeded: function(){
      // clear states which dose not reside in Redux store

      // clear Redux store states
      this.props.resetActiveCondition();
  },

  hasDataLoaded: function(){
      return !!(this.props.conditions);
  },

  pageTitle: 'Gastrointestinal (GI) Infections, Diseases and Disorders',

  getContent: function(){
      var children = [
          <ContentHeader key={'content-header'} />,
          <div className="main-wrapper row" key={'main-wrapper'}>
              <div className="column large-6 medium-10 medium-centered small-12">
                  <div className="hero-text-block">
                      <h2>Welcome to the Gi Treatment Center</h2>
                      <p>There are many therapies available for each GI condition. GI conditions can be complex and the best treatment depends on many factors. MyGiHealth does not endorse a preferred therapy for any specific GI conditions. You should have an informed discussion with your doctor to develop an effective treatment plan.</p>
                  </div>
                  <ConditionNavList
                      className="condition-nav"
                      conditions={this.props.conditions}
                      activeCondition={this.props.activeCondition}
                      setActiveCondition={this.props.setActiveCondition}
                      clickTracking={this.props.recordConditionClick} />
              </div>
          </div>,
          <div className="app-promo-wrapper" key={'app-promo-wrapper'}>
              <div className="row column">
                  <AppPromo
                      pageTitle={this.pageTitle}
                      recordDownloadClick={this.props.recordDownloadClick} />
              </div>
          </div>
      ];

      var content = (
          <Loader loaded={this.hasDataLoaded()}>
              {children}
          </Loader>
      );

      if(this.hasDataLoaded()){
          content = children;
      }

      return content;
  },

  render: function () {
    return (
        <div className="content">
            <Helmet
                title={this.pageTitle}
                meta={[{
                    name: 'description',
                    content: 'Learn more about GI tract illnesses. Provides a list of gastrointestinal diseases, with details for each. Download MyGiHealth free, to track symptoms.'
                }]}
            />

            {this.getContent()}
        </div>
    );
  }
});

module.exports = Conditions;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/conditions.jsx